export default "__VITE_ASSET__CDVbbcCw__"